/**
 * #useractions.ts
 *
 * Code generated by ts-proto. DO NOT EDIT.
 * @packageDocumentation
 */
/* eslint-disable */
import _m0 from "protobufjs/minimal.js";
import { messageTypeRegistry } from "../../../../typeRegistry.js";
function createBaseUserGeneratedContent() {
    return { text: "", imageUrls: [] };
}
export const UserGeneratedContent = {
    $type: "reddit.devvit.useractions.v1.UserGeneratedContent",
    encode(message, writer = _m0.Writer.create()) {
        if (message.text !== "") {
            writer.uint32(10).string(message.text);
        }
        for (const v of message.imageUrls) {
            writer.uint32(18).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUserGeneratedContent();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.text = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.imageUrls.push(reader.string());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            text: isSet(object.text) ? globalThis.String(object.text) : "",
            imageUrls: globalThis.Array.isArray(object?.imageUrls)
                ? object.imageUrls.map((e) => globalThis.String(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.text !== "") {
            obj.text = message.text;
        }
        if (message.imageUrls?.length) {
            obj.imageUrls = message.imageUrls;
        }
        return obj;
    },
    create(base) {
        return UserGeneratedContent.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUserGeneratedContent();
        message.text = object.text ?? "";
        message.imageUrls = object.imageUrls?.map((e) => e) || [];
        return message;
    },
};
messageTypeRegistry.set(UserGeneratedContent.$type, UserGeneratedContent);
function isSet(value) {
    return value !== null && value !== undefined;
}
